<template>
	<div>


      <b-tabs v-if="settings_loaded" content-class="mt-3" v-model="tabIndex" v-on:activate-tab="checkSave">

        <b-tab :active="urlhash == 'colours-fonts' ? true : false" v-if="company_admin" title="Colours & Fonts">
          <form ref="exampleCardPreviewForm" action="/company/preview" method="POST" target="accountPreview">

          <div class="row">
            <b-form-group
                  label="Brand Accent Colour:"
                  label-for="accent_color"
                  description="This will be applied to card headlines, buttons and some card backgrounds."
                  class="col-md-6"
                >
              <div v-if="settings_loaded"><company-color-picker name="accent_color" :value="settings.accent_color" @change="updatePreviews('accent_color',$event)"></company-color-picker></div>
            </b-form-group>
            <b-form-group
                  label="Additional Colours:"
                  label-for="secondary_color"
                  description="You can define additional brand colours here for quick selection."
                  class="col-md-6"
                >
              <div v-if="settings_loaded"><company-color-picker name="secondary_color" :value="settings.secondary_color" @change="updatePreviews('secondary_color',$event)"></company-color-picker></div>
              <div v-if="settings_loaded"><company-color-picker name="tertiary_color" :value="settings.tertiary_color" @change="updatePreviews('tertiary_color',$event)"></company-color-picker></div>
            </b-form-group>
          </div> 

          <hr />
          <div class="row">
            <b-form-group
                  label="Heading Font"
                  label-for="heading_font"
                  class="col-md-5"
                >
                  <b-form-select id="heading_font" name="heading_font" v-model="settings.heading_font" :options="settings.font_select" @change="updatePreviews('heading_font',settings.heading_font)"></b-form-select>
            </b-form-group>
            <b-form-group
                  label="Heading Size"
                  label-for="heading_size"
                  class="col-md-2"
                >
                  <b-form-spinbutton id="heading_size" v-model="settings.heading_size" name="heading_size" min="1" max="4" @change="updatePreviews('heading_size',settings.heading_size)"></b-form-spinbutton>
            </b-form-group>
            <b-form-group
                  label="Heading Colour:"
                  label-for="contrast_color"
                  description="This is default colour of your headings."
                  class="col-md-5"
                >
              <div v-if="settings_loaded"><company-color-picker name="heading_color" :value="settings.heading_color" @change="updatePreviews('heading_color',$event)"></company-color-picker></div>
            </b-form-group>

          </div>
          <div class="row">
            <b-form-group
                  label="Text Font"
                  label-for="body_font"
                  class="col-md-5"
                >
                  <b-form-select id="body_font" name="body_font" v-model="settings.body_font" :options="settings.font_select" @change="updatePreviews('body_font',settings.body_font)"></b-form-select>
            </b-form-group>
            <b-form-group
                  label="Text Size"
                  label-for="body_size"
                  class="col-md-2"
                >
                  <b-form-spinbutton id="body_size" v-model="settings.body_size" name="body_size" min="1" max="4" @change="updatePreviews('body_size',settings.body_size)"></b-form-spinbutton>
            </b-form-group>
            <b-form-group
                  label="Text Colour:"
                  label-for="contrast_color"
                  description="This is default colour of the body copy text."
                  class="col-md-5"
                >
              <div v-if="settings_loaded"><company-color-picker name="contrast_color" :value="settings.contrast_color" @change="updatePreviews('contrast_color',$event)"></company-color-picker></div>
            </b-form-group>

          </div>
                    <hr />

          <div class="row">
            <b-form-group
                  label="Card Background Colour:"
                  label-for="ground_color"
                  description="This is default background colour for cards in your SizzleDeck."
                  class="col-md-4"
                >
              <div v-if="settings_loaded"><company-color-picker name="ground_color" :value="settings.ground_color" @change="updatePreviews('ground_color',$event)"></company-color-picker></div>
            </b-form-group>
            <b-form-group
                  label="Button Colour:"
                  label-for="button_background_color"
                  description="This is default colour of the body copy text."
                  class="col-md-4"
                >
              <div v-if="settings_loaded"><company-color-picker name="button_background_color" :value="settings.button_background_color" @change="updatePreviews('button_background_color',$event)"></company-color-picker></div>
            </b-form-group>
            <b-form-group
                  label="Button Text Colour:"
                  label-for="button_text_color"
                  description="This is default colour of the body copy text."
                  class="col-md-4"
                >
              <div v-if="settings_loaded"><company-color-picker name="button_text_color" :value="settings.button_text_color" @change="updatePreviews('button_text_color',$event)"></company-color-picker></div>
            </b-form-group>
          </div>
          <input type="hidden" name="_token" :value="csrf">
          </form>
                    <hr />

          <div class="row">
            <b-form-group label="Preview" class="col-12">
              <div id="buildArea" class="border p-3 w-100">
                <div class="iframe-container-preloader">
                  <iframe class="border-0" src="/company/preview" width="100%" height="650" ref="accountPreviewIframe" id="accountPreview" name="accountPreview" @load="unhidePreview('accountPreviewIframe')"></iframe>
                </div>
              </div>
            </b-form-group>
          </div>


        </b-tab>
        <b-tab :active="urlhash == '#images-backgrounds' ? true : false" title="Images & Backgrounds">
          
          <b-form-group
                label="Company Logo"
                label-for="company_logo"

                v-if="company_admin"
              >
              <div class="row justify-content-center">
                <div class="col-3">
                  
                  <div v-if="settings_loaded"><company-logo input-id="company_logo" name="company_logo" :image="settings.logo" @change="updatePreviews('logo',$event)"></company-logo></div>
                  
                </div>
              </div>
          </b-form-group>      

          <b-form-group
                label="Profile Pic"
                label-for="profile_pic"
              >
              <div class="row justify-content-center">
                <div class="col-3">
                
                  
                  <div v-if="settings_loaded"><mini-profile-image :makecircle="true" input-id="profile_pic" name="profile_pic" :image="settings.profile_pic" @change="updatePreviews('profile_pic',$event)"></mini-profile-image></div>

                </div>
              </div>
          </b-form-group>

          <b-form-group
                label="Default Deck Background"
                label-for="background"
                v-if="company_admin"
              >
              <div class="row justify-content-center">
                <div class="col">
                  <div v-if="settings_loaded"><deck-background input-id="background" name="background" :image="settings.background" @change="updatePreviews('background',$event)"></deck-background></div>
                </div>
              </div>
          </b-form-group>

        </b-tab>
        <b-tab :active="urlhash == '#mini-profile' ? true : false" title="Mini Profile">
            
            <b-form-group
                description="Can be overridden on a per deck basis."
                label-for="default_show_profile"
                class="pt-3"
              >
                <b-form-checkbox id="show_miniprofile" v-model="settings.mini_profile_state" name="check-button" @change="updatePreviews()" switch>
                  {{ settings.mini_profile_show ? 'Show': 'Hide'}} Show Profile 
                </b-form-checkbox>
            </b-form-group>



            <b-row v-if="settings.mini_profile_state">              

            <b-col>


              


          <form ref="miniProfilePreviewForm" action="/deck/mini-profile-preview" method="POST" target="miniProfilePreview">

            <b-form-group
                  label="Mini Profile Image"
                  label-for="miniProfileImage"
                  description="eg. Logo or Headshot"
                >
                                <div class="row justify-content-center">
                    <div class="col-md-12">             
                          <b-form-radio-group
                                  v-model="settings.mini_profile_image_style"
                                  :options="[{ text: 'Normal', value: 'normal' },
                                             { text: 'Round', value: 'round' },
                                             { text: 'Hide', value: 'hidden' }]"
                                  button-variant="outline-primary"
                                  
                                  name="mini_profile_image_style"
                                  buttons
                                  class="mb-3"
                                  @change="updatePreviews('mini_profile_image_style',$event)"
                                ></b-form-radio-group>
                    </div>
                </div>
                <div class="row justify-content-center" v-if="settings.mini_profile_image_style !== 'hidden' && changingImageStyle == false">
                  <div class="col-md-8">                   

                    <div v-if="settings_loaded">
                      <div v-if="settings.mini_profile_image_style == 'round'">
                      <mini-profile-image :makecircle="true" input-id="mini_profile_image_round" name="mini_profile_image" :image="settings.mini_profile_image" @change="updatePreviews('mini_profile_image',$event)"></mini-profile-image>
                      </div>
                      <div v-else>
                      <mini-profile-image :makecircle="false" input-id="mini_profile_image_normal" name="mini_profile_image" :image="settings.mini_profile_image" @change="updatePreviews('mini_profile_image',$event)"></mini-profile-image>
                      </div>
                    </div>
    

                  </div>
                </div>
            </b-form-group>

            <b-form-group
                label="Name"
                label-for="mini_profile_name"
              >
                <b-form-input id="mini_profile_name" name="mini_profile_name" v-model="settings.mini_profile_name" :required="true" @change="updatePreviews()" @keyup="updatePreviews()" trim></b-form-input>
            </b-form-group>

            <b-form-group
                label=" Text"
                description="A short sentence that explains who you are/what you do."
                label-for="mini_profile_text"
              >
                <b-form-textarea id="mini_profile_text" name="mini_profile_text" v-model="settings.mini_profile_text" :required="false" @change="updatePreviews()" @keyup="updatePreviews()" trim></b-form-textarea>
            </b-form-group>

              <b-form-group
                label="Should there be a button on the mini profile?"
                label-for="mini_profile_button_state"
                class="pt-3"
              >
                <b-form-radio-group
                  v-model="settings.mini_profile_button_state"
                  :options="[{ text: 'Link to Profile Card', value: 'profile' },
                             { text: 'Other Link', value: 'link' },
                             { text: 'Hide Button', value: 'hide' }]"
                  button-variant="outline-primary"
                  
                  name="mini_profile_button_state"
                  buttons
                  class="mb-3"
                  @change="updatePreviews()"
                ></b-form-radio-group>

              </b-form-group>

            <b-form-group
                label="Button Text"
                label-for="mini_profile_button_text"
                 v-if="settings.mini_profile_button_state !== 'hide'"
              >
                <b-form-input id="mini_profile_button_text" name="mini_profile_button_text" v-model="settings.mini_profile_button_text" :required="true" @change="updatePreviews()" @keyup="updatePreviews()" trim></b-form-input>
            </b-form-group>

              <b-form-group
                label="Button Link"
                label-for="mini_profile_button_link"
                v-if="settings.mini_profile_button_state == 'link'"
              ><b-input-group>
                <b-form-input id="mini_profile_button_link_domain" name="mini_profile_button_link_domain" v-model="miniProfileButtonLinkDomain" :required="false" @change="updatePreviews()" trim></b-form-input>
                    <template #prepend>

                      <b-form-select id="mini_profile_button_link_protocol" name="mini_profile_button_link_protocol" class="rounded-left" v-model="miniProfileButtonLinkProtocol" :options="[{ value: 'http://', text: 'http://'},{ value: 'https://', text: 'https://'},{ value: 'tel:', text: 'tel:'},{ value: 'mailto:', text: 'mailto:'}]" @change="updatePreviews()"></b-form-select>
                     
                    </template>
                  </b-input-group>
                  <input type="hidden" name="mini_profile_button_link" :value="settings.mini_profile_button_link">
              </b-form-group>
              <input type="hidden" name="_token" :value="csrf">
              </form>

            </b-col>
            <b-col>
              <div class="iframe-container-preloader">
              <iframe class="border-0" src="/deck/mini-profile-preview" width="100%" height="450" ref="miniProfilePreviewIframe" id="miniProfilePreview" name="miniProfilePreview" @load="unhidePreview('miniProfilePreviewIframe')">Preview Loading...</iframe>
              </div>
            </b-col>
            </b-row>

        </b-tab>
        <b-tab :active="urlhash == '#profile-card' ? true : false" title="Profile Card">
          
            <b-row>              

            <b-col>          


          <form ref="fullProfilePreviewForm" action="/deck/profile-preview" method="POST" target="profilePreview">
            

            <b-row>
            <b-col>

            <b-form-group
                label="First Name"
                label-for="profile_first_name"
              >
                <b-form-input id="profile_first_name" name="profile_first_name" v-model="settings.profile_first_name" :required="true" @change="updatePreviews()" @keyup="updatePreviews()" trim></b-form-input>
            </b-form-group>

            </b-col><b-col>

            <b-form-group
                label="Last Name"
                label-for="profile_last_name"
              >
                <b-form-input id="profile_last_name" name="profile_last_name" v-model="settings.profile_last_name" :required="true" @change="updatePreviews()" @keyup="updatePreviews()" trim></b-form-input>
            </b-form-group>

            </b-col>
            </b-row>

            <b-form-group
                label=" Text"
                description="A short paragraph that explains who you are/what you do."
                label-for="profile_text"
              >
                <b-form-textarea id="profile_text" name="profile_text" v-model="settings.profile_text" :required="false" @change="updatePreviews()" @keyup="updatePreviews()" trim></b-form-textarea>
            </b-form-group>

            <b-form-group
                  label="Profile Image"
                  label-for="profileImage"
                  description="eg. Logo or Headshot"
                >
                <div class="row justify-content-center">
                    <div class="col-md-12">             
                          <b-form-radio-group
                                  v-model="settings.profile_image_style"
                                  :options="[{ text: 'Normal', value: 'normal' },
                                             { text: 'Round', value: 'round' },
                                             { text: 'Hide', value: 'hidden' }]"
                                  button-variant="outline-primary"
                                  
                                  name="profile_image_style"
                                  buttons
                                  class="mb-3"
                                  @change="updatePreviews('profile_image_style',$event)"
                                ></b-form-radio-group>
                    </div>
                </div>
                <div class="row justify-content-center" v-if="settings.profile_image_style !== 'hidden' && changingImageStyle == false">
                  <div class="col-md-8">                    

                    <div v-if="settings_loaded">
                      <div v-if="settings.profile_image_style == 'round'">
                      <mini-profile-image :makecircle="true" input-id="profile_image_round" name="profile_image" :image="settings.profile_image" @change="updatePreviews('profile_image',$event)"></mini-profile-image>
                      </div>
                      <div v-else>
                      <mini-profile-image :makecircle="false" input-id="profile_image_normal" name="profile_image" :image="settings.profile_image" @change="updatePreviews('profile_image',$event)"></mini-profile-image>
                      </div>
                    </div>

                  </div>
                </div>

            </b-form-group>

       
              <b-form-group
                label="Email Address"
                description="This will appear on your company profile."
                label-for="display_email"
              >
                <b-input-group>
                  <b-form-input id="display_email" v-model="settings.display_email" :required="false" @change="updatePreviews()" trim></b-form-input>
                  <b-input-group-append is-text>
                    <b-form-checkbox id="display_email_state" v-model="settings.display_email_state" @change="updatePreviews()" switch></b-form-checkbox>
                  </b-input-group-append>
                </b-input-group>
                <input type="hidden" name="display_email_state" :value="settings.display_email_state">
              </b-form-group>

              <b-form-group
                label="Call Telephone Number"
                label-for="profile_telephone"
              >
                <b-input-group>
                  <vue-tel-input v-model="settings.profile_telephone" :value="settings.profile_telephone" id="profile_telephone" name="profile_telephone" placeholder="" mode="international" :required="true" @input="updatePreviews()"></vue-tel-input>
                  <b-input-group-append is-text>
                    <b-form-checkbox id="profile_telephone_state" v-model="settings.profile_telephone_state" @change="updatePreviews()" switch></b-form-checkbox>
                  </b-input-group-append>
                </b-input-group>
                <input type="hidden" name="profile_telephone_state" :value="settings.profile_telephone_state">
              </b-form-group>

              <b-form-group
                label="SMS Telephone Number"
                label-for="profile_sms"
              >
                <b-input-group>
                  <vue-tel-input v-model="settings.profile_sms" :value="settings.profile_sms" id="profile_sms" name="profile_sms" placeholder="" mode="international" :required="true" @input="updatePreviews()"></vue-tel-input>
                  <b-input-group-append is-text>
                    <b-form-checkbox id="profile_sms_state" v-model="settings.profile_sms_state" @change="updatePreviews()" switch></b-form-checkbox>
                  </b-input-group-append>
                </b-input-group>
                <input type="hidden" name="profile_sms_state" :value="settings.profile_sms_state">
              </b-form-group>
         

              <b-form-group
                label="Website URL"
                label-for="website"
              ><b-input-group>
                <b-form-input id="website" v-model="websiteDomain" :required="false" @change="updatePreviews()" trim></b-form-input>
                    <template #prepend>
                      <b-form-select class="rounded-left" v-model="websiteProtocol" :options="[{ value: 'http://', text: 'http://'},{ value: 'https://', text: 'https://'}]" @change="updatePreviews()"></b-form-select>
                    </template>
                    <b-input-group-append is-text>
                      <b-form-checkbox id="profile_website_state" v-model="settings.profile_website_state" @change="updatePreviews()" switch></b-form-checkbox>
                    </b-input-group-append>
                  </b-input-group>
                  <input type="hidden" name="profile_website" :value="settings.profile_website">
                  <input type="hidden" name="profile_website_state" :value="settings.profile_website_state">
              </b-form-group>
              
              <b-form-group
                label="Twitter URL"
                label-for="twitter"
              >
                <b-input-group :prepend="twitterPrefix">
                  <b-form-input id="twitter" v-model="twitterURL" :required="false" @change="updatePreviews()" trim></b-form-input>
                  <b-input-group-append is-text>
                    <b-form-checkbox id="profile_twitter_state" v-model="settings.profile_twitter_state" @change="updatePreviews()" switch></b-form-checkbox>
                  </b-input-group-append>
                </b-input-group>
                <input type="hidden" name="profile_twitter" :value="settings.profile_twitter">
                <input type="hidden" name="profile_twitter_state" :value="settings.profile_twitter_state">
              </b-form-group>

              <b-form-group
                label="Linkedin URL"
                label-for="linkedin"
              >
              <b-input-group :prepend="linkedinPrefix">
                <b-form-input id="linkedin" v-model="linkedinURL" :required="false" @change="updatePreviews()" trim></b-form-input>
                <b-input-group-append is-text>
                  <b-form-checkbox id="profile_linkedin_state" v-model="settings.profile_linkedin_state" @change="updatePreviews()" switch></b-form-checkbox>
                </b-input-group-append>
              </b-input-group>
              <input type="hidden" name="profile_linkedin" :value="settings.profile_linkedin">
              <input type="hidden" name="profile_linkedin_state" :value="settings.profile_linkedin_state">
              </b-form-group>

              <b-form-group
                label="Facebook URL"
                label-for="facebook"
              >
              <b-input-group :prepend="facebookPrefix">
                <b-form-input id="facebook" v-model="facebookURL" :required="false" @change="updatePreviews()" trim></b-form-input>
                <b-input-group-append is-text>
                    <b-form-checkbox id="profile_facebook_state" v-model="settings.profile_facebook_state" @change="updatePreviews()" switch></b-form-checkbox>
                </b-input-group-append>
              </b-input-group>
              <input type="hidden" name="profile_facebook" :value="settings.profile_facebook">
              <input type="hidden" name="profile_facebook_state" :value="settings.profile_facebook_state">
              </b-form-group>

              <b-form-group
                label="Instagram URL"
                label-for="instagram"
              >
                <b-input-group :prepend="instagramPrefix">
                  <b-form-input id="instagram" v-model="instagramURL" :required="false" @change="updatePreviews()" trim></b-form-input>
                  <b-input-group-append is-text>
                    <b-form-checkbox id="profile_instagram_state" v-model="settings.profile_instagram_state" @change="updatePreviews()" switch></b-form-checkbox>
                  </b-input-group-append>
                </b-input-group>
                <input type="hidden" name="profile_instagram" :value="settings.profile_instagram">
                <input type="hidden" name="profile_instagram_state" :value="settings.profile_instagram_state">
              </b-form-group>

              <b-form-group
                label="Custom Button"
                label-for="custom_button_url"
              >

                <b-input-group>
                  <b-form-input id="custom_button_url" v-model="customButtonDomain" :required="false" @change="updatePreviews()" trim></b-form-input>
                    <template #prepend>

                      <b-form-select class="rounded-left" v-model="customButtonProtocol" :options="[{ value: 'http://', text: 'http://'},{ value: 'https://', text: 'https://'}]" @change="updatePreviews()"></b-form-select>
                     
                    </template>
                  </b-input-group>
                  </b-form-group>

              <b-form-group
                description="eg. Calendly"
                label-for="custom_button_text"
              >
                  <b-input-group>
                    <b-form-input placeholder="Button Text" id="custom_button_text" v-model="settings.profile_custom_button_text" name="profile_custom_button_text" :required="false" @change="updatePreviews()" trim></b-form-input>
                  <b-input-group-append is-text>
                    <b-form-checkbox id="custom_button_state" v-model="settings.profile_custom_button_state" @change="updatePreviews()" switch></b-form-checkbox>
                  </b-input-group-append>
                  <input type="hidden" name="profile_custom_button_state" :value="settings.profile_custom_button_state">
                </b-input-group>

                  <input type="hidden" name="profile_custom_button_link" :value="settings.profile_custom_button_link">
              </b-form-group>



              <input type="hidden" name="_token" :value="csrf">
              </form>

            </b-col>
            <b-col>
              <div class="iframe-container-preloader">
              
              <iframe class="border-0" src="/deck/profile-preview" width="100%" height="1000" ref="profilePreviewIframe" id="profilePreview" name="profilePreview" @load="unhidePreview('profilePreviewIframe')">Preview Loading...</iframe>
              
              </div>
            </b-col>
            </b-row>

        </b-tab>




        <b-tab :active="urlhash == '#advanced' ? true : false" title="Advanced Settings">

            <b-form-group
                label="SMS Sender ID "
                label-for="sms_send_number"
              >
                <b-form-input id="sms_send_number" name="sms_send_number" v-model="settings.sms_send_number" :required="true" @change="updatePreviews()" @keyup="updatePreviews()" trim></b-form-input>
            </b-form-group>

              <b-form-group
                label="Deck URL"
                label-for="slug"
                v-if="company_admin"
              >
              <b-input-group prepend="https://" :append="hosting_domain">
                <b-form-input id="slug" v-model="settings.slug" :required="true" @change="updatePreviews" trim></b-form-input>
              </b-input-group>
              </b-form-group>

        </b-tab>
      </b-tabs>


      <b-button class="pull-right" @click="saveSettings()">Save Settings</b-button>



  </div>
</template>

<script>

import axios from 'axios';
import Noty from 'noty';
import debounce from 'debounce';



export default {
  mounted() {
    this.csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    this.loadSettings();
    
  },
  props: [
      'hosting_domain'
  ],
  data() {
    return {
      csrf: null,
		  settings_loaded: false,
      changingImageStyle: false,
      unsaved: false,
      tabIndex: 0,
      settings:[],
      font_select:[],
      company_admin: false,
      size_select:[
          { value: '1', text: 'Small' },
          { value: '2', text: 'Medium' },
          { value: '3', text: 'Large' },
          { value: '4', text: 'X-Large' }
        ],
      websiteProtocol:'',
      websiteDomain:'',
      customButtonProtocol:'',
      customButtonDomain:'',
      miniProfileButtonLinkProtocol:'',
      miniProfileButtonLinkDomain:'',
      facebookPrefix:'https://www.facebook.com/',
      facebookURL:'',
      twitterPrefix:'https://twitter.com/',
      linkedinURL:'',
      linkedinPrefix:'https://linkedin.com/',
      twitterURL:'',
      instagramPrefix:'https://www.instagram.com/',
      instagramURL:'',
      urlhash: new URL(window.location.href).hash.replace('#/','')
    };
  },
  methods: {
        loadSettings: function(newTabIndex=null){
            var vm = this;
            vm.settings_loaded = false;
            axios.get('/deck/settings/get').then(response => {

              vm.settings = response.data;

              vm.company_admin = vm.settings.company_admin;

              if(vm.settings.profile_twitter == null){vm.settings.profile_twitter = '';}
              vm.twitterURL = vm.settings.profile_twitter.replace(vm.twitterPrefix, "");;
              if(vm.settings.profile_facebook == null){vm.settings.profile_facebook = '';}
              vm.facebookURL = vm.settings.profile_facebook.replace(vm.facebookPrefix, "");;
              if(vm.settings.profile_linkedin == null){vm.settings.profile_linkedin = '';}
              vm.linkedinURL = vm.settings.profile_linkedin.replace(vm.linkedinPrefix, "");;
              if(vm.settings.profile_instagram == null){vm.settings.profile_instagram = '';}
              vm.instagramURL = vm.settings.profile_instagram.replace(vm.instagramPrefix, "");;

              if(vm.settings.profile_website == null){vm.settings.profile_website = '';}
              if(vm.settings.profile_website.indexOf("http://") !== -1){
                vm.websiteProtocol = 'http://';
              }else{
                vm.websiteProtocol = 'https://';
              }

              vm.websiteDomain = vm.settings.profile_website.replace(/(^\w+:|^)\/\//, '');

              if(vm.settings.profile_custom_button_link == null){vm.settings.profile_custom_button_link = '';}
              if(vm.settings.profile_custom_button_link.indexOf("http://") !== -1){
                vm.customButtonProtocol = 'http://';
              }else{
                vm.customButtonProtocol = 'https://';
              }

              vm.customButtonDomain = vm.settings.profile_custom_button_link.replace(/(^\w+:|^)\/\//, '');


              if(vm.settings.mini_profile_button_link == null){vm.settings.mini_profile_button_link = '';}
              if(vm.settings.mini_profile_button_link.indexOf("http://") !== -1){
                vm.miniProfileButtonLinkProtocol = 'http://';
              }else{
                vm.miniProfileButtonLinkProtocol = 'https://';
              }

              vm.miniProfileButtonLinkDomain = vm.settings.mini_profile_button_link.replace(/(^\w+:|^)\/\//, '');


              vm.settings_loaded = true;
              vm.unsaved = false;
              if(newTabIndex !== null){
                vm.tabIndex = newTabIndex;
              }

            }).catch(function(error){ vm.handleError(error) });


        },
        saveSettings: function(currentTabIndex=null,newTabIndex=null){
            var vm = this;
            if(vm.settings_loaded){

              axios.post('/deck/settings/update',vm.settings).then(response => {

                if(response.data.status == 'success'){
                    vm.unsaved = false;
                  if(newTabIndex !== null){
                      vm.tabIndex = newTabIndex;
                  }
                  vm.showNoty('success','Settings Saved',3000);
                }else{
                  vm.showNoty('error',response.data.message,3000);
                }               

              }).catch(function(error){ vm.handleError(error) });

            }else{
              vm.showNoty('error','Still loading, please try again',3000);
            }

        },
        checkSave: function(newTabIndex,currentTabIndex, event){
          var vm = this;

          if(vm.unsaved){
              event.preventDefault();
              var n = new Noty({
                    text: 'You have unsaved changes. Would you like to save them?',
                    theme: 'bootstrap-v4',
                    type: 'alert',
                    layout: 'topCenter',
                    timeout: false,  
                    buttons: [
                    Noty.button('Don\'t Save', 'btn btn-secondary', function () {
                        vm.settings_loaded = false;
                        vm.loadSettings(newTabIndex);
                        n.close();
                    }),
                    Noty.button('Save', 'btn btn-primary pull-right', function () {
                        vm.saveSettings(currentTabIndex,newTabIndex);
                        n.close();
                    })
                    ],

              }).show();
          }

        },
        updatePreviews: function(setting=null,value=null){

          var vm = this;
          vm.unsaved = true;
          if(setting){
            vm.settings[setting]=value;
          }

          if(
            setting == 'profile_image_style' ||
            setting == 'mini_profile_image_style'
            ){

            vm.changingImageStyle = true;
            setTimeout(function(){
              vm.changingImageStyle = false;
            }, 600);   

            }
          //console.log('setting',setting);
          //console.log('value',value);

          vm.$nextTick(function () {
            vm.debouncePreviews();
          });

        },

        unhidePreview: function(iframeref){
          console.log(iframeref);
          this.$refs[iframeref].style.opacity = '1';
        },
        debouncePreviews: debounce(function (e) {

            this.$refs.profilePreviewIframe.style.opacity = '0';

            this.$refs.miniProfilePreviewForm.submit();
            this.$refs.fullProfilePreviewForm.submit();
            this.$refs.exampleCardPreviewForm.submit();

        }, 1200),


        updateCompanyLogo: function(value) {
          this.settings.logo = value;
        },
        updateBackground: function(value) {
          this.settings.background = value;
        },
        updateProfileBackground: function(value) {
          this.settings.profile_background = value;
        },
        handleError: function(error){

            if(error.response.status == '419'){
              this.showLoggedOutNoty();
            }else{
              this.showGeneralErrorNoty();
            }

        },
        showNoty: function(type='warning',message='',timeout=false){
          new Noty({
                    text: message,
                    type: type,
                    theme: 'bootstrap-v4',
                    layout: 'topCenter',
                    timeout: timeout
                }).show();
        },
        showGeneralErrorNoty: function(){
          new Noty({
                    text: 'There has been an error. Please <a href="javascript:window.location.reload(true)">refresh this page</a> and try again.',
                    type: 'error',
                    theme: 'bootstrap-v4',
                    layout: 'topCenter',
                    timeout: false
                }).show();
        },
        showLoggedOutNoty: function(){
          new Noty({
              text: 'You have been logged out due to inactivity. Please <a href="javascript:window.location.reload(true)">refresh this page</a> to login.',
              type: 'error',
              theme: 'bootstrap-v4',
              layout: 'topCenter',
              timeout: false
          }).show();
        },  
   },
    watch: {
        websiteProtocol(){
          if(this.websiteDomain==''){this.settings.website = null;}else{
          	this.settings.profile_website = this.websiteProtocol+this.websiteDomain;
          }
        },
        websiteDomain(){
          if(this.websiteDomain==''){this.settings.website = null;}else{
          	this.settings.profile_website = this.websiteProtocol+this.websiteDomain;
          }
        },
        customButtonProtocol(){
          if(this.customButtonDomain==''){this.settings.profile_custom_button_link = null;}else{
            this.settings.profile_custom_button_link = this.customButtonProtocol+this.customButtonDomain;
          }
        },
        customButtonDomain(){
          if(this.customButtonDomain==''){this.settings.profile_custom_button_link = null;}else{
            this.settings.profile_custom_button_link = this.customButtonProtocol+this.customButtonDomain;
          }
        },
        miniProfileButtonLinkDomain(){
          if(this.miniProfileButtonLinkDomain==''){this.settings.mini_profile_button_link = null;}else{
            this.settings.mini_profile_button_link = this.miniProfileButtonLinkProtocol+this.miniProfileButtonLinkDomain;
          }
        },
        miniProfileButtonLinkProtocol(){
          if(this.miniProfileButtonLinkDomain==''){this.settings.mini_profile_button_link = null;}else{
            this.settings.mini_profile_button_link = this.miniProfileButtonLinkProtocol+this.miniProfileButtonLinkDomain;
          }
        },
        twitterURL(){
          this.settings.profile_twitter = this.twitterPrefix+this.twitterURL;
        },
        linkedinURL(){
          this.settings.profile_linkedin = this.linkedinPrefix+this.linkedinURL;
        },
        facebookURL(){
          this.settings.profile_facebook = this.facebookPrefix+this.facebookURL;
        },
        instagramURL(){
          this.settings.profile_instagram = this.instagramPrefix+this.instagramURL;
        },
        profileSettings:{
          handler(newValue, oldValue) {
            this.settings.mini_profile_button_link = this.settings.mini_profile_button_link_protocol+this.settings.mini_profile_button_link_domain;
          },
          deep: true
        }
    },
    computed: {

    }
  }
</script>

<style type="text/css">
  .iframe-container-preloader iframe{
    background: transparent;
  }
  .iframe-container-preloader{
    background-image: url('/images/Spinner-1s-200px.gif');
    background-size: 150px 150px;
    background-position: center 50px;
    background-repeat: no-repeat;
    display: block;
    /*position: absolute;*/
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    min-height: 350px;
  }
</style>